/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppWarehousesRouteImport } from './routes/_app/warehouses'
import { Route as AppShipmentsRouteImport } from './routes/_app/shipments'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSampleTestsRouteImport } from './routes/_app/sample-tests'
import { Route as AppPlanRouteImport } from './routes/_app/plan'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppHistoryRouteImport } from './routes/_app/history'
import { Route as AppGoodsRouteImport } from './routes/_app/goods'
import { Route as AppFlowRouteImport } from './routes/_app/flow'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppCustomersRouteImport } from './routes/_app/customers'
import { Route as AppShipmentsShipmentIdRouteImport } from './routes/_app/shipments_.$shipmentId'
import { Route as AppOrdersOrderIdRouteImport } from './routes/_app/orders_.$orderId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWarehousesRoute = AppWarehousesRouteImport.update({
  id: '/warehouses',
  path: '/warehouses',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsRoute = AppShipmentsRouteImport.update({
  id: '/shipments',
  path: '/shipments',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSampleTestsRoute = AppSampleTestsRouteImport.update({
  id: '/sample-tests',
  path: '/sample-tests',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanRoute = AppPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppRoute,
} as any)
const AppGoodsRoute = AppGoodsRouteImport.update({
  id: '/goods',
  path: '/goods',
  getParentRoute: () => AppRoute,
} as any)
const AppFlowRoute = AppFlowRouteImport.update({
  id: '/flow',
  path: '/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsShipmentIdRoute = AppShipmentsShipmentIdRouteImport.update({
  id: '/shipments_/$shipmentId',
  path: '/shipments/$shipmentId',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: '/orders_/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/customers': typeof AppCustomersRoute
  '/dashboard': typeof AppDashboardRoute
  '/flow': typeof AppFlowRoute
  '/goods': typeof AppGoodsRoute
  '/history': typeof AppHistoryRoute
  '/orders': typeof AppOrdersRoute
  '/plan': typeof AppPlanRoute
  '/sample-tests': typeof AppSampleTestsRoute
  '/settings': typeof AppSettingsRoute
  '/shipments': typeof AppShipmentsRoute
  '/warehouses': typeof AppWarehousesRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/shipments/$shipmentId': typeof AppShipmentsShipmentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/customers': typeof AppCustomersRoute
  '/dashboard': typeof AppDashboardRoute
  '/flow': typeof AppFlowRoute
  '/goods': typeof AppGoodsRoute
  '/history': typeof AppHistoryRoute
  '/orders': typeof AppOrdersRoute
  '/plan': typeof AppPlanRoute
  '/sample-tests': typeof AppSampleTestsRoute
  '/settings': typeof AppSettingsRoute
  '/shipments': typeof AppShipmentsRoute
  '/warehouses': typeof AppWarehousesRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/shipments/$shipmentId': typeof AppShipmentsShipmentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/customers': typeof AppCustomersRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/flow': typeof AppFlowRoute
  '/_app/goods': typeof AppGoodsRoute
  '/_app/history': typeof AppHistoryRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/plan': typeof AppPlanRoute
  '/_app/sample-tests': typeof AppSampleTestsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/shipments': typeof AppShipmentsRoute
  '/_app/warehouses': typeof AppWarehousesRoute
  '/_app/orders_/$orderId': typeof AppOrdersOrderIdRoute
  '/_app/shipments_/$shipmentId': typeof AppShipmentsShipmentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/customers'
    | '/dashboard'
    | '/flow'
    | '/goods'
    | '/history'
    | '/orders'
    | '/plan'
    | '/sample-tests'
    | '/settings'
    | '/shipments'
    | '/warehouses'
    | '/orders/$orderId'
    | '/shipments/$shipmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/customers'
    | '/dashboard'
    | '/flow'
    | '/goods'
    | '/history'
    | '/orders'
    | '/plan'
    | '/sample-tests'
    | '/settings'
    | '/shipments'
    | '/warehouses'
    | '/orders/$orderId'
    | '/shipments/$shipmentId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/customers'
    | '/_app/dashboard'
    | '/_app/flow'
    | '/_app/goods'
    | '/_app/history'
    | '/_app/orders'
    | '/_app/plan'
    | '/_app/sample-tests'
    | '/_app/settings'
    | '/_app/shipments'
    | '/_app/warehouses'
    | '/_app/orders_/$orderId'
    | '/_app/shipments_/$shipmentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/warehouses': {
      id: '/_app/warehouses'
      path: '/warehouses'
      fullPath: '/warehouses'
      preLoaderRoute: typeof AppWarehousesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments': {
      id: '/_app/shipments'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof AppShipmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sample-tests': {
      id: '/_app/sample-tests'
      path: '/sample-tests'
      fullPath: '/sample-tests'
      preLoaderRoute: typeof AppSampleTestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plan': {
      id: '/_app/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof AppPlanRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/history': {
      id: '/_app/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/goods': {
      id: '/_app/goods'
      path: '/goods'
      fullPath: '/goods'
      preLoaderRoute: typeof AppGoodsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/flow': {
      id: '/_app/flow'
      path: '/flow'
      fullPath: '/flow'
      preLoaderRoute: typeof AppFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments_/$shipmentId': {
      id: '/_app/shipments_/$shipmentId'
      path: '/shipments/$shipmentId'
      fullPath: '/shipments/$shipmentId'
      preLoaderRoute: typeof AppShipmentsShipmentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders_/$orderId': {
      id: '/_app/orders_/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCustomersRoute: typeof AppCustomersRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppFlowRoute: typeof AppFlowRoute
  AppGoodsRoute: typeof AppGoodsRoute
  AppHistoryRoute: typeof AppHistoryRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppPlanRoute: typeof AppPlanRoute
  AppSampleTestsRoute: typeof AppSampleTestsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppShipmentsRoute: typeof AppShipmentsRoute
  AppWarehousesRoute: typeof AppWarehousesRoute
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
  AppShipmentsShipmentIdRoute: typeof AppShipmentsShipmentIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCustomersRoute: AppCustomersRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppFlowRoute: AppFlowRoute,
  AppGoodsRoute: AppGoodsRoute,
  AppHistoryRoute: AppHistoryRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppPlanRoute: AppPlanRoute,
  AppSampleTestsRoute: AppSampleTestsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppShipmentsRoute: AppShipmentsRoute,
  AppWarehousesRoute: AppWarehousesRoute,
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppShipmentsShipmentIdRoute: AppShipmentsShipmentIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
